const uuid = require('uuid');
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

const _ = {
    forEach:    require('lodash/forEach'),
    filter:     require('lodash/filter'),
    find:       require('lodash/find'),
    findIndex:  require('lodash/findIndex'),
    map:        require('lodash/map'),
}

const RichText = require('@muzzylane/react-mzl/dist/RichText');

const Globals = require('../../../../../app/globals');
const ShortCourseConstants = require('../../../../../app/shared/ShortCourseConstants');

import AccessibleIcon from '../../common/AccessibleIcon';
import AlwaysScrollToBottom from '../../common/AlwaysScrollToBottom';

const AssetUtil = require('../../../util/asset');

const ReactMzlUtils = require('../../../util/ReactMzlUtils');

import StudentContentBlockPlayButton from '../../ShortCourseInstance/StudentContentBlockPlayButton';
import CoachScriptElements from './CoachScriptElements';
import ShortCoursePlayStore from '../../../stores/ShortCoursePlayStore';
const FLOW_FOCI = ShortCoursePlayStore.FLOW_FOCI;

// This component is shown when playing a course and a single node has been selected
class ShortCourseNode extends React.Component {
    constructor(props) {
        super(props);
        this.playStore = this.props.playStore;
        const doc = this.props.playStore.getDoc();
        this.app = ReactMzlUtils.getAppForSharedComponents({ course_hash: doc.hash, getDoc: this.props.playStore.getDoc }); // for RichText from react-mzl
        let ss = this.getStoreState(props);
        this.state ={...ss, 
            selected_cb_hash: null,
            quickScoreModalData: null,
            showRecommendation: false, // used for redmine #6166 note 14, wait for continue click before showing recommendations
        };
        this.unsubscribes = [this.playStore.getStore().listen(this.onPlayChange)];
    }
    
//    componentDidMount() {
//        window.addEventListener('resize', this.updateStickerPosition);
//        this.updateStickerPosition();
//    }
    
    componentWillUnmount() {
//        window.removeEventListener('resize', this.updateStickerPosition);
        this.unsubscribes.forEach(u => u());
        delete this.unsubscribes;
    }

//    onScroll=()=>{
//        this.updateStickerPosition();
//    }

//    updateStickerPosition=()=>{
//        var domNode = $("#coach-sticker")[0];
//        if (domNode) {
//            let elem = $(".coach-lower-sticker-shape")[0]; // non-react element
//            if (elem) {
//                let relativeTo = $(".coach-conversation")[0].getBoundingClientRect();
//                let stickerBr = domNode.getBoundingClientRect();
//                let br = elem.getBoundingClientRect();
//                let scrollElem = $(".scroll-content.coach-size");
//                let scrollTop = scrollElem.scrollTop() || 0;
//                let stickerOffsetLeft = Math.round(br.left - relativeTo.left);
//                let stickerOffsetTop = Math.round(br.top - relativeTo.top - scrollTop - (stickerBr.height - br.height));
//                this.setState({
//                    stickerOffsetLeft: stickerOffsetLeft,
//                    stickerOffsetTop: stickerOffsetTop,
//                });                    
//            }
//        }
//    }

	getStoreState=(props)=>{
        const doc = this.playStore.getDoc();
        const node = _.find(doc.nodes,{node_id: props.node_id});
        const selected_cb_hash = null; // not using this for gatherCoachDataForNode // this.state ? this.state.selected_cb_hash : null;
        let { next_cb_info, possible_next_cbs, bot_infos } = this.playStore.gatherCoachDataForNode(props.node_id,selected_cb_hash,props.activities);
        let remedial = next_cb_info && next_cb_info.remedial;
        let top_recommendations;
        if (remedial) {
            top_recommendations =  possible_next_cbs.slice(0,3); // top 3
        }
        else {
            top_recommendations =  possible_next_cbs.slice(0,4); // first 4 per redmine #6258
        }
        let optional_bot_info = bot_infos && bot_infos[0];
        
        return { 
            node, 
            next_cb_info,
            top_recommendations,
            remedial,
            optional_bot_info,
        };
	}
	
    onPlayChange=(storeState)=>{
		// console.log(`ShortCourseNode ${this.props.node_id} onPlayChange`);
		this.setState(this.getStoreState(this.props));
    }
    
    selectActivity=(selected_cb_hash)=>{
        if (this.state.selected_cb_hash === selected_cb_hash) {
            this.setState({selected_cb_hash: null}); // unselect
        }
        else {
            this.setState({selected_cb_hash});
        }
    }
    
    attemptContentBlock=(info)=>{
        this.playStore.actions.attemptContentBlock({node_id: this.props.node_id, content_block_hash: info.hash});
    }
    
    openQuickAttemptScoreModal=(info)=>{
        const doc = this.props.playStore.getDoc();
        const node_id = this.props.node_id;
        const cb = this.props.playStore.getContentBlock(info.hash);
        // let activity = this.props.playStore.getInfoActivity(info);
        if (cb) {
            let quickScoreModalData = {
                info: info,
                subskills: [],
            };
            _.forEach(cb.subskill_relations,(xref,hash)=>{
                let subskill_id = _.findIndex(doc.subskills,{hash}); // simulated subskill_id for preview
                let ss = doc.subskills[subskill_id];
                if (ss && ss.node_relations[node_id]) {
                    quickScoreModalData.subskills.push({
                        hash,
                        display_name: ss.display_name,
                        score: 100,
                    });
                }
            }); // forEach cb.subskill_relations
            this.setState({quickScoreModalData});
        }
    }
       
    setQuickScoreValue=(i,e)=>{
        let quickScoreModalData = {...this.state.quickScoreModalData };
        quickScoreModalData.subskills[i].score = e.target.value;
        this.setState({quickScoreModalData});
    }

    finishQuickScore=()=>{
        const quickScoreModalData = this.state.quickScoreModalData;
        const info = quickScoreModalData.info;
        const doc = this.props.playStore.getDoc();
        const node_id = this.props.node_id;
        const cb = this.props.playStore.getContentBlock(info.hash);
        
        // generate scoreData 
        let scoreData = {
            score: 100, 
            score_categories: [],
        };
        
        _.forEach(cb.subskill_relations,(xref,hash)=>{
            let subskill_id = _.findIndex(doc.subskills,{hash}); // simulated subskill_id for preview
            let ss = doc.subskills[subskill_id];
            if (ss && ss.node_relations[node_id]) {
                const entry = _.find(quickScoreModalData.subskills,{hash});
                if (entry) {
                    if (xref.cb_score_type === Globals.short_course.content_block_score_req_type.OVERALL) {
                        scoreData.score = entry.score;
                    }
                    else {
                        scoreData.score_categories.push({
                            category_id: xref.objective_name,
                            display_name: ss.display_name, 
                            score: entry.score,
                            max_score: 100,
                        });
                    }
                }
            }
        }); // forEach cb.subskill_relations
        this.setState({quickScoreModalData: null, showRecommendation:false},()=>{
            this.playStore.actions.addContentBlockAttempt({hash: info.hash, scoreData});
            this.playStore.actions.goToPostAttemptScreen(); // possibly via timeout
        });
    }

    
    cancelQuickScore=()=>{
        this.setState({quickScoreModalData: null});
    }
    
    
    getInfoMetaData=(info)=>{
        return this.playStore.getInfoMetaData(info);
    }
    
    // returns recommendedElement, playButtonElement
    generateContentBlockElements=()=>{
        let recommendedElement;
        let playButtonElement;

        let next_cb_info = this.state.next_cb_info;
        if (next_cb_info && !this.state.showRecommendation) {
            return { recommendedElement, playButtonElement};
        }
        const optional_bot_info = this.state.optional_bot_info;

        const preview = this.playStore.getIsPreview();
        
        let selected_cb_index = _.findIndex(this.state.top_recommendations,{hash: this.state.selected_cb_hash});
        let selected_cb_info = this.state.top_recommendations[selected_cb_index];
        if (!selected_cb_info && next_cb_info) {
            selected_cb_index = _.findIndex(this.state.top_recommendations,{hash: next_cb_info.hash});
        }
        if (optional_bot_info && (this.state.selected_cb_hash === optional_bot_info.hash)) {
            // bot alternative selected.
            selected_cb_info = optional_bot_info;
        }
        
        let showPlayButton = this.playStore.canAdvanceCoachScript() ? false : true;
        let canDoInstaScore = false; // redmine #6201
        if (showPlayButton) {
            // const doc = this.props.playStore.getDoc();
            canDoInstaScore = preview; // || (doc.user && doc.user.admin); // need to simulate 'complete' callback to do this in non-preview (deferred)
        }
        if (next_cb_info || selected_cb_info || optional_bot_info) {
            const botOnly = (!next_cb_info || selected_cb_info);
            let info = selected_cb_info || next_cb_info || optional_bot_info;
            let first_info = info;
            let second_index = (selected_cb_index + 1) % this.state.top_recommendations.length;
            let second_info = (this.state.top_recommendations.length > 1) && this.state.top_recommendations[second_index];
            
            let third_index = (selected_cb_index + 2) % this.state.top_recommendations.length;
            let third_info = (this.state.top_recommendations.length > 2) && this.state.top_recommendations[third_index];
            
            let secondElem;
            if (second_info) {
                let {img_src, description} = this.getInfoMetaData(second_info);
                secondElem = (
                    <div className="activity-choice second-element" onClick={this.selectActivity.bind(this,second_info.hash)}>
                        <div className="secondary-image-wrapper">
                            <img className="activity-image" src={img_src}/>
                        </div>
                        <h2>{second_info.name}</h2>
                    </div>
                );
            }
            let thirdElem;
            if (third_info) {
                let {img_src, description} = this.getInfoMetaData(third_info);
                thirdElem = (
                    <div className="activity-choice third-element" onClick={this.selectActivity.bind(this,third_info.hash)}>
                        <div className="secondary-image-wrapper">
                            <img className="activity-image" src={img_src}/>
                        </div>
                        <h2>{third_info.name}</h2>
                    </div>
                );
            }
    
            let botElem;
            if (optional_bot_info && !botOnly) {
                let {img_src, description} = this.getInfoMetaData(optional_bot_info);
                botElem = (
                    <div className="bot-selection">
                        <div className="activity-choice bot-element" onClick={this.selectActivity.bind(this,optional_bot_info.hash)}>
                            <div className="bot-image-wrapper">
                                <img className="activity-image" src={img_src}/>
                            </div>
                            <h2>{optional_bot_info.name}</h2>
                        </div>
                    </div>
                );
            }
            
            { 
                let {img_src, description, desc1, desc2 } = this.getInfoMetaData(first_info);
                recommendedElement = (
                    <div className="coach-recommendations">
                        <div className={"activity-choice selected-element" + (secondElem ? " partial-width" : " full-width")}>
                            <h2>{first_info.name}</h2>
                            <div className="main-image-wrapper">
                                <img className="activity-image" src={img_src}/>
                            </div>
                            <div className="activity-description">{description}</div>
                            <div className="activity-bottom-section">
                                { desc1 ? <div className="left-description"><span>{desc1}</span></div> : null }
                                { desc2 ? <div className="right-description"><span>{desc2}</span></div> : null }
                            </div>
                        </div>
                        { secondElem ? 
                        <div className="other-selections">
                            {secondElem}
                            {thirdElem}
                        </div>
                        : null }
                        { botElem }
                    </div>
                );
            }
            
            let internal_play = (first_info && first_info.type === Globals.short_course.content_block_type.CHATBOT);

            if (showPlayButton) {
                playButtonElement = (
                    <div className="play-button-area">
                        { (preview || internal_play) ?
                        <button className="btn btn-primary short-course-play-button" onClick={()=>{this.attemptContentBlock(first_info)}}>
                            play
                        </button>
                        : 
                        <StudentContentBlockPlayButton
                            instanceHash={this.props.instanceHash}
                            contentBlockHash={first_info.hash}
                            courseNodeInstance={this.state.node}
                        />
                        }
                        { canDoInstaScore ?
                        <button className="btn btn-primary short-course-play-button" onClick={()=>{this.openQuickAttemptScoreModal(first_info)}}>
                            quick score
                        </button>
                        : null }
                    </div>
                )
            }
        }
        return { recommendedElement, playButtonElement };
    }
    
    onAudioFinish=()=>{
        // we could advance the coach here, but we don't want to.
    }
    
    advanceCoach=()=>{
        this.props.playStore.actions.updatePersistentFlags();
        if (this.props.playStore.canAdvanceReportCard()) {
            this.props.playStore.actions.advanceReportCard((phase)=>{
                // if this component is not going away, go on to the next step after finishing the report card (redmine #6209)
                if (this.unsubscribes && (phase === ShortCoursePlayStore.REPORT_CARD_PHASE.END)) {
                    return this.advanceCoach();
                }
            });
            return;
        }
        
        if (this.props.playStore.canAdvanceCoachScript()) {
            return this.props.playStore.actions.advanceCoachScript();
        }
        
        let flowFocus = this.playStore.getFlowFocus(); 
        if (flowFocus === FLOW_FOCI.WelcomeScreen) {
            return this.props.playStore.actions.exitWelcomeScreen();
        }
        
        if (this.state.next_cb_info && !this.state.showRecommendation) {
            this.setState({showRecommendation: true});
        }
    }

    render() {
        //let nodeClasses = "node-content";
        //if (this.state.prerequisitesSatisfied) {
        //    nodeClasses += " available";
        //}
        let { recommendedElement, playButtonElement } = this.generateContentBlockElements();
        
        let modalElement;
        if (this.state.quickScoreModalData) {
            playButtonElement = null;
            modalElement = (
                <Modal show enforceFocus={false} autoFocus backdrop={false} animation={false} keyboard={false} onHide={this.cancelQuickScore} >
                    <Modal.Header>
                        <Modal.Title>{"Quick Score"}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    {_.map(this.state.quickScoreModalData.subskills,(entry,i)=>(
                        <div className="subskill-row" key={i}>
                            <label>{entry.display_name}</label>
                            <input type="range" value={entry.score} min={0} max={100} onChange={this.setQuickScoreValue.bind(this,i)}/>
                            <input type="number" value={entry.score} min={0} max={100} onChange={this.setQuickScoreValue.bind(this,i)}/>
                        </div>
                    ))}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.finishQuickScore}>{"Proceed"}</Button>
                    </Modal.Footer>
                </Modal>
            );
        }
        
        let channelWidth = this.props.channelWidth || '1rem';
        
        // let includePriorCoachElements = (!this.playStore.canAdvanceCoachScript() && this.state.next_cb_info);
        
        return (
            <div className="short-course-expanded-play-node" style={{top: channelWidth}}>
                <div className="scroll-area">
                    <div className="coach-area">
                        <div className="scroll-content coach-size">
                            <CoachScriptElements 
                                app={this.app}
                                playStore={this.props.playStore}
                                activityElement={recommendedElement}
                                includePriorCoachElements={ true }
                                onAudioFinish={ this.onAudioFinish }
                                />
                            { playButtonElement ? 
                            <div className="bottom-button-area">
                                { playButtonElement }
                            </div>
                            :
                            <div className="bottom-button-area">
                                <button className="btn btn-primary continue-button" onClick={ this.advanceCoach }>
                                    {'Continue'}
                                </button>
                            </div>
                            }
                            <AlwaysScrollToBottom/>
                        </div>
                    </div>
                </div>
                {modalElement}
            </div>
        );
    }
};

export default ShortCourseNode;